import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SessionSignalsStateService } from '../application/session/session-store.service';

@Injectable({
  providedIn: 'root',
})
export class IsUnsignedInGuard implements CanActivate {
  private sessionStore = inject(SessionSignalsStateService);
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    if (this.sessionStore.select('isLogged')()) {
      return this.router.createUrlTree(['']);
    }

    return true;
  }
}
